module.exports = __webpack_public_path__ + "static/media/gold-tokens.f7295779.png";